import { AccountUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/crm/v1/account_events_pb';
import { Col, DiffViewer, FieldDisplay, IDField } from '@rematter/ui-web';

import { accountTypeLabels } from '../enumLabels';

type AccountUpdatedDetailProps = {
  event: AccountUpdatedEvent;
};

export const AccountUpdatedDetail = ({ event }: AccountUpdatedDetailProps) => {
  const previous = event.previousAccount;
  const current = event.updatedAccount;

  if (!previous || !current) {
    return (
      <Col className="@AccountUpdatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const diffs = [
    {
      field: 'name',
      label: 'Name',
      previous: previous.name,
      current: current.name,
    },
    {
      field: 'accountType',
      label: 'Account Type',
      previous: accountTypeLabels[previous.accountType],
      current: accountTypeLabels[current.accountType],
    },
    {
      field: 'isCustomer',
      label: 'Is Customer',
      previous: previous.isCustomer ? 'Yes' : 'No',
      current: current.isCustomer ? 'Yes' : 'No',
    },
    {
      field: 'isSupplier',
      label: 'Is Supplier',
      previous: previous.isSupplier ? 'Yes' : 'No',
      current: current.isSupplier ? 'Yes' : 'No',
    },
    {
      field: 'email',
      label: 'Email',
      previous: previous.email,
      current: current.email,
    },
    {
      field: 'phone',
      label: 'Phone',
      previous: previous.phone,
      current: current.phone,
    },
    {
      field: 'website',
      label: 'Website',
      previous: previous.website,
      current: current.website,
    },
    {
      field: 'notes',
      label: 'Notes',
      previous: previous.notes,
      current: current.notes,
    },
  ];

  return (
    <Col className="@AccountUpdatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">Account</span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={current.id?.value} />
          <FieldDisplay label="Name" value={current.name} />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          Changes
        </span>
        <DiffViewer diffs={diffs} previousLabel="Before" currentLabel="After" />
      </Col>
    </Col>
  );
};
